import { View } from '@adobe/react-spectrum';
import React from 'react';
import styled from 'styled-components';

import { useStaticData } from '@exchange-frontends/custom-hooks';
import { SAP_CODE_TO_ICON_ID, azSort, getProductNames } from '@exchange-frontends/utils';

const ProductContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  box-sizing: border-box;
`;

const ProductIcon = styled.svg`
  height: 24px;
  width: 24px;
`;

const ProductName = styled.span`
  margin-left: 8px;
  left: 5px;
  bottom: 4px;
`;

const CompatibleAppsContainer = styled.ul`
  margin-top: 0;
  padding: 0;
  li:not(:last-child) {
    margin-bottom: var(--spectrum-global-dimension-size-200);
  }
`;

const SupportedApps = ({ filteredSupportedProducts, supportedProducts }) => {
  const productsLocs = useStaticData('hostApps');

  const makeCCSupportedProductObjectsArray = (sapCodes, locs) => {
    sapCodes = sapCodes?.map((sapCode) => {
      return sapCode.hostAppCode;
    });
    const uniqueProductSAPCodes = Array.from(new Set(sapCodes));
    const productNames = getProductNames(uniqueProductSAPCodes, locs);
    return uniqueProductSAPCodes
      .map((key, idx) => ({ key, name: productNames[idx] }))
      .sort((a, b) => azSort(a.name, b.name));
  };

  const CCSupportedProducts = makeCCSupportedProductObjectsArray(supportedProducts, productsLocs);

  // get icon label
  const getHostAppLabel = (hostAppCode) => {
    const CCSupportedProduct = CCSupportedProducts.find((supportedProduct) => supportedProduct.key === hostAppCode);
    return CCSupportedProduct?.name;
  };

  return (
    <>
      {filteredSupportedProducts?.length > 0 && (
        <>
          <View marginBottom="size-200">Compatible apps:</View>
          <CompatibleAppsContainer>
            {filteredSupportedProducts.map((product) => (
              <li key={product.hostAppCode}>
                <ProductContainer key={product.hostAppCode}>
                  <ProductIcon viewBox="0 0 240 234" data-testid="product-icon" role="presentation">
                    <use xlinkHref={`#${SAP_CODE_TO_ICON_ID[product.hostAppCode]}`} />
                  </ProductIcon>
                  <ProductName>
                    {getHostAppLabel(product.hostAppCode)}{' '}
                    {product.minVersion + (product.maxVersion ? ' - ' + product.maxVersion : ' or higher')}
                  </ProductName>
                </ProductContainer>
              </li>
            ))}
          </CompatibleAppsContainer>
        </>
      )}
    </>
  );
};

export default SupportedApps;
